<template>
  <NormalHeaderLayout header="MockData">
    <div class="form-group">
      <label for="routing-status">
        Mock Data for Routing Status
      </label>
      <p>
        (If any data exists here, it will be used to replace the
        /routing-status/ API response.)
      </p>
      <textarea
        class="form-control"
        id="routing-status"
        rows="10"
        ref="routingStatus"
        :value="routingStatusMockData"
      ></textarea>
      <p v-if="error.routingStatus" class="text-danger">
        Error: {{ error.routingStatus }}
      </p>
      <div class="btn-group">
        <button class="btn btn-primary" @click="loadData('routingStatus')">
          Load Data
        </button>
        <button class="btn btn-secondary" @click="clearData('routingStatus')">
          Clear Data
        </button>
      </div>

      <!-- {{ JSON.stringify(mockDataObj) }} -->
    </div>
  </NormalHeaderLayout>
</template>

<script>
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout.vue';

export default {
  name: 'MockData',
  components: {
    NormalHeaderLayout
  },
  data() {
    return {
      mockDataObj: { routingStatus: {} },
      error: {
        routingStatus: ''
      }
    };
  },
  computed: {
    routingStatusMockData: {
      get() {
        return this.mockDataObj.routingStatus
          ? JSON.stringify(this.mockDataObj.routingStatus)
          : '';
      }
    }
  },
  methods: {
    clearData(type) {
      this.mockDataObj[type] = null;
      this.error[type] = '';
      sessionStorage.setItem('mock_data', JSON.stringify(this.mockDataObj));
    },
    loadData(type) {
      const selectedText = this.$refs[type].value;
      let obj;

      try {
        obj = JSON.parse(selectedText);

        this.error.routingStatus = '';
        this.mockDataObj.routingStatus = obj;

        sessionStorage.setItem('mock_data', JSON.stringify(this.mockDataObj));
      } catch (error) {
        this.error.routingStatus = error;
      }
    }
  },
  mounted() {
    const mockData = sessionStorage.getItem('mock_data');

    if (mockData) {
      const mockDataObj = JSON.parse(mockData);

      if (mockDataObj) this.mockDataObj = mockDataObj;
    }
  },
  destroyed() {
    location.reload();
  }
};
</script>

<style lang="scss" scoped>
.form-group {
  label {
    font-weight: 600;
  }

  .btn-group {
    margin-top: 1rem;

    button {
      margin-right: 1rem;
    }
  }
}</style
>>
